import { useEffect, useState } from "react";
import api from "@/api/client";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export default function ParcelTypeSelect({ value, onChange, testid = "parcel-type-select" }) {
  const [types, setTypes] = useState(["Document","Parcel","Letter","Box","Package","Envelope","Other"]);
  useEffect(() => { api.get("/parcel-types").then(r => setTypes(r.data)).catch(()=>{}); }, []);
  return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger data-testid={testid} className="rounded-md border-input focus:ring-primary mt-1">
        <SelectValue placeholder="Select type" />
      </SelectTrigger>
      <SelectContent className="rounded-md">
        {types.map(t => <SelectItem key={t} value={t}>{t}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
